import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useOfflineMode } from '@/providers/OfflineModeProvider'
import { useAppSelector } from '@/redux/rootReducer'
import { selectIsAuthenticated } from '@/redux/reducers/auth.reducer'

type ProtectedOfflinePageProps = {
    children: React.ReactElement
}

export default function ProtectedOfflinePage({ children }: ProtectedOfflinePageProps) {
    const location = useLocation()
    const { isOfflineMode, canAccessOfflineMode } = useOfflineMode()

    // Check if user is authenticated (from Redux)
    const isAuthenticated = useAppSelector(selectIsAuthenticated)

    // Allow access to offline pages if:
    // 1. User is in offline mode
    // 2. User can access offline mode (has valid cached data)
    // 3. User is authenticated (even when online - for poor connectivity)
    if (!isOfflineMode && !canAccessOfflineMode && !isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />
    }

    return children
} 